import * as React from 'react';

import { useSinglePackage } from './hooks';
import { SinglePackage } from './SinglePackage';

export const SinglePackageContainer = () => {
  const { label, checked, handlePackageChange } = useSinglePackage();

  return <SinglePackage label={label} checked={checked} handleChange={handlePackageChange} />;
};
